import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { compose, withProps, withState } from 'recompose';

import theme from '../../../theme';
import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import FileDndable from '../primitive/FileDndable';
import FileSelectButton from '../primitive/FileSelectButton';

type Props = ClassAttributes<HTMLElement> & {
  onRequestFileUpload: (files: FileList) => void;
  className?: string;
};

type InnerProps = Props & {
  isDragging: boolean;
  setIsDragging: (isDragging: boolean) => void;
  onSelectFile: (e: any, files: FileList) => void;
  onDrop: (files: FileList) => void;
};

const FileUploader = compose<InnerProps, Props>(
  withState('isDragging', 'setIsDragging', false),
  withProps(({ onRequestFileUpload }: Props) => {
    const _onRequestFileUpload = (files: FileList) => {
      if (files.length === 0) return;

      onRequestFileUpload(files);
    };

    return {
      onSelectFile: (_: any, files: FileList) => _onRequestFileUpload(files),
      onDrop: (files: FileList) => _onRequestFileUpload(files),
    };
  }),
)(({ className, isDragging, setIsDragging, onSelectFile, onDrop }) => (
  <Root onDrop={onDrop} onChangeDragging={setIsDragging} className={className} isDragging={isDragging}>
    <Text variant="h6">Drag and drop file into here, or</Text>

    <FileSelectButton color="default" variant="contained" onSelectFile={onSelectFile}>
      Select
    </FileSelectButton>
  </Root>
));

const Root = styled(FileDndable)<{ isDragging: boolean }>(({ isDragging }) => ({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  backgroundColor: theme.palette.grey['100'],
  border: isDragging ? `2px ${theme.palette.primary.light} solid` : `2px ${theme.palette.grey['200']} solid`,
  borderRadius: 8,
  transform: `border ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms`,
  '> *': {
    margin: `${SPACING_UNIT}px 0`,
  },
}));

const Text = styled(Typography)({
  color: theme.palette.grey['400'],
  userSelect: 'none',
});

export default FileUploader;
